<template>
  <v-app :theme="theme">
    <AppBar v-model="navDrawerModel" />
    <NavigationDrawer v-model="navDrawerModel" />
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script lang="ts">
import { useColorMode } from '@vueuse/core'
import { computed, defineComponent, ref } from 'vue'

import AppBar from '@/components/AppBar.vue'
import NavigationDrawer from '@/components/NavigationDrawer.vue'

export default defineComponent({
  name: 'App',

  components: {
    AppBar,
    NavigationDrawer,
  },

  setup () {
    const mode = useColorMode()
    const theme = computed(() => {
      return mode.value
    })

    const navDrawerModel = ref(true)

    return {
      theme,
      navDrawerModel,
    }
  },
})
</script>
